import { recordAction } from '../actions/fetchrecord'
import { recordMutation } from '../mutations/fetchrecord'

export const record = {
  state: {
    'order/list': {
      data: [],
      total: 0
    },
    'calendar/list': {
      data: [],
      total: 0
    }
  },
  mutations: recordMutation,
  actions: recordAction
}
